<template>
    <client-only>
        <Gallery :list="items" />
    </client-only>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'
    import {Gallery, setGallery} from 'vue-preview-imgs'

    @Component({
        components: {
            Gallery,
        },
    })
    export class VPhotoSwipe extends Vue {
        @VModel() photoSwipeIsOpen
        @Prop({required: true}) items
        @Prop({default: () => ({index: 0})}) photoSwipeOptions

        list = []

        mounted() {
            this.items.forEach(item => {
                this.list.push(this.gettingData(item))
            })
        }

        async openLightbox(i) {
            const lightbox = setGallery({
                dataSource: this.list,
            })

            lightbox.loadAndOpen(i)
        }

        gettingData(data) {
            const item = data

            if (item.src && (item.w < 1 || item.h < 1)) {
                // unknown size
                const img = new Image()
                img.onload = function () {
                    // will get size after load
                    item.w = this.width // set image width
                    item.h = this.height // set image height
                }
                img.src = item.src // let's download image

                return item
            }
        }
    }

    export default VPhotoSwipe
</script>
